export type SysaElement = {
    readonly id?: number; // e.g. 1;
    readonly text?: string | null; // e.g. "Copied product 'Harry’s War' to your cart.";
    readonly type?: string; // e.g. 'info';
};

export type NotificationInfo = {
    title: string;
    message: string;
    dataDisplay: string;
    dataRaw: string;
    callback: Function;
    showCancel: boolean;
    submitLabel: string;
};

export type NotificationsState = {
    readonly sysa: ReadonlyArray<SysaElement>;
    readonly info?: NotificationInfo | null;
};

export function isNotificationInfo(info: NotificationInfo | null): info is NotificationInfo {
    return info !== null && 'title' in info;
}
